import EcoIconPlay from 'eco-design-micro/icons/eco-icon-play';
import EcoButton from 'eco-design/base/eco-button';
import EcoImg from 'eco-design/base/eco-img';
import EcoSpaceSmall from 'eco-design/base/eco-space-small';
import EcoDialogVideo from 'eco-design/elements/eco-dialog-video';
import EcoSectionCommon from 'eco-design/elements/eco-section-common';
import { useRouter } from 'next/router';
import { useState } from 'react';
import EcoSpace from 'eco-design/base/eco-space';
import { useProductStore } from '../../../../ProductProvider';
import { IPageStatus } from '../../../../config/IPageStatus';
import styles from './index.module.scss';
import { useLang } from '@/i18n';
export default function Comp() {
    const { t } = useLang('theProduct');
    const { locale = 'us' } = useRouter();
    const [openA, setOpenA] = useState(false);
    const srcObjA: any = {
        us: 'https://www.youtube.com/embed/beMBax2XG34',
        jp: 'https://www.youtube.com/embed/17BQ3N0YpME',
        eu: 'https://www.youtube.com/embed/9Hpv5FzlDpU',
        uk: 'https://www.youtube.com/embed/9Hpv5FzlDpU',
        de: 'https://www.youtube.com/embed/Lm-GOSFUcV8',
        fr: 'https://www.youtube.com/embed/33HQloFrOmQ',
        it: 'https://www.youtube.com/embed/07dQh78BY7w',
        es: 'https://www.youtube.com/embed/y_EE3Mipoio',
    };
    const videoSrc = srcObjA[locale] || srcObjA['us'];
    const { pageStatus } = useProductStore();

    const openHandle = () => {
        setOpenA(true);
    };
    const closeHandle = () => {
        setOpenA(false);
    };
    return (
        <div className={styles.comp} id="SectionD">
            <EcoSpace />
            <EcoSectionCommon title={t('K_title')} desc={t('K_desc')} />
            <EcoButton
                lChildren={t('K_watch')}
                className="comp-btn"
                onClick={openHandle}
                lIconR={<EcoIconPlay />}
                lType="outlined"
                lRadius="ellipse"
                lDataLayer={{
                    event: 'uaEvent',
                    event_name: 'video',
                    title_name: t('K_title'),
                    position: `Product Detail_${pageStatus === IPageStatus.statusA ? 1 : 2}`,
                }}
            />
            <EcoSpaceSmall />
            <EcoImg
                pc={
                    locale === 'jp'
                        ? 'https://websiteoss.ecoflow.com/upload/image/1745721252673/d.jpg'
                        : 'https://websiteoss.ecoflow.com/upload/image/1744702803862/D.jpg'
                }
                className="eco-content comp-img"
            />
            {openA && <EcoDialogVideo open={openA} src={videoSrc} callback={closeHandle} />}
        </div>
    );
}
